/* eslint-disable no-undef */
import { GoogleMap, MarkerF } from '@react-google-maps/api';
import { Modal } from 'flowbite';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { Loader } from '../components/utils';
import { AddCase } from '../services/Common';

const Map = ({
  locations,
  configInfo,
  activeMarker,
  centerValue,
  searchMarker,
  searchSelection,
  appDir,
  activeMarkerCallBack,
  getMarkers,
}) => {
  const options = useMemo(
    () => ({
      placement: 'bottom-right',
      backdrop: 'dynamic',
      backdropClasses:
        'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40',
      closable: true,
      onHide: () => {
        document.body.style.overflow = 'unset';
      },
      onShow: () => {
        document.body.style.overflow = 'hidden';
      },
      onToggle: () => {},
    }),
    []
  );

  const { t } = useTranslation();

  const handleFileInput = useRef(null);
  const handlePhotoInput = useRef(null);
  const [direction, setDirection] = useState('ltr');
  const [caseDetails, setCaseDetails] = useState({});

  const [docImageObject, setDocImageObject] = useState([]);
  const [photoImageObject, setPhotImageObject] = useState([]);
  const [markers, setMarkers] = useState([]);
  const defaultCenter = { lat: 25.172675338538472, lng: 55.33506405170034 };
  const isValidLatLng = (value) =>
    Number.isFinite(value?.lat) && Number.isFinite(value?.lng);
  const [center, setCenter] = useState(
    isValidLatLng(centerValue) ? centerValue : defaultCenter
  );
  const [actMarker, setActMarker] = useState(null);
  const [locationStatuses, setLocationStatuses] = useState([]);
  const [locationContent, setLocationContent] = useState([]);
  const [occupiants, setOccupants] = useState([]);
  const [hazardLevels, setHazardLevels] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [years, setYears] = useState([]);
  const [modal, setModal] = useState();

  const [slocationContentId, setLocationContentId] = useState({});
  const [slocationStatusId, setLocationStatusId] = useState({});
  const [soccupiantsId, setOccupantsId] = useState({});
  const [sfileNumber, setFileNumber] = useState({});
  const [sfileYear, setFileYear] = useState({});
  const [sfileTypeId, setFileTypeId] = useState();
  const [sguardianname, setGuardianName] = useState('');
  const [sDocumentTypId, setDocumentTypId] = useState();
  const [sNeedKeyNumber, setNeedKeyNumber] = useState(true);
  const [smakaniNumber, setMakaniNumber] = useState('');
  const [shazardLevel, setHazardLevel] = useState();
  const [sGx, setGx] = useState({});
  const [sGy, setGy] = useState({});
  const [isView, setIsView] = useState(true);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    setMarkers(locations);
  }, [locations]);
  useEffect(() => {
    setDirection(appDir);
  }, [appDir]);

  useEffect(() => {
    if (isValidLatLng(centerValue)) setCenter(centerValue);
  }, [centerValue]);

  useEffect(() => {
    setLocationStatuses(configInfo.locationStatuses);
    setLocationContent(configInfo.locationContent);
    setDocumentTypes(configInfo.documentTypes);

    const now = new Date().getUTCFullYear();
    setYears(
      Array(now - (now - 20))
        .fill('')
        .map((v, idx) => now - idx)
    );
    setFileYear(2023);
    setOccupants(configInfo.occupiants);
    setHazardLevels(configInfo.hazardLevels);
    const fileType = [];
    configInfo?.fileTypes?.forEach((type) => {
      fileType.push({ value: type.id, label: type.title });
    });
    setFileTypes(fileType);
  }, [configInfo]);
  useEffect(() => {
    const $targetEl = document.getElementById('modalEl');
    setModal(new Modal($targetEl, options));
  }, [options]);

  const handleSubmit = () => {
    if (loading) return;

    const missingFields = [];
    const normalizedMakaniNumber = String(smakaniNumber).replace(/\s+/g, '');
    const makaniNumberValue = normalizedMakaniNumber;
    const gxValue = Number(sGx);
    const gyValue = Number(sGy);
    const data = {
      locationContentId: slocationContentId,
      locationStatusId: slocationStatusId,
      occupiantsId: 1,
      fileNumber: sfileNumber,
      fileYear: sfileYear,
      guardian: sguardianname,
      gx: '' + sGx,
      gy: '' + sGy,
      fileTypeId: sfileTypeId,
      hazardLevel: slocationContentId === 3 ? shazardLevel : 1,
      makaniNumber: makaniNumberValue,
      needKeyNumber: sNeedKeyNumber,
      documentType: sDocumentTypId,
      documents: docImageObject,
      photos: photoImageObject,
    };

    if (slocationContentId === 0 || slocationContentId === '')
      missingFields.push('Location content');
    if (slocationStatusId === 0 || slocationStatusId === '')
      missingFields.push('Location status');
    if (sfileNumber === 0 || sfileNumber === '')
      missingFields.push('File number');
    if (sfileYear === 0 || !sfileYear) missingFields.push('File year');
    if (sguardianname === 0 || sguardianname === null)
      missingFields.push('Guardian name');
    if (!/^\d+$/.test(makaniNumberValue))
      missingFields.push('Makani number');
    if (!Number.isFinite(gxValue)) missingFields.push('Location latitude');
    if (!Number.isFinite(gyValue)) missingFields.push('Location longitude');

    if (missingFields.length > 0) {
      setSubmitError(
        `Please fill required fields: ${missingFields.join(', ')}.`
      );
      return;
    }

    setSubmitError('');
    setLoading(true);
    return AddCase(data)
      .then(() => {
        modal.hide();
        getMarkers();
        setSubmitError('');
      })
      .catch((error) => {
        setSubmitError(
          error?.message || 'Unable to submit case. Please try again.'
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleActiveMarker = useCallback(
    (details) => {
      console.log('====================================');
      console.log(details);
      setCaseDetails(details);
      console.log('====================================');
      setLocationContentId(0);
      setLocationStatusId(0);
      setFileYear(2023);
      setFileNumber();
      setOccupantsId(0);
      setGx('');
      setGy('');
      setIsView(true);
      setCenter({ lat: +details.gx, lng: +details.gy });
      setLocationContentId(details.locationContentId);
      setLocationStatusId(details.locationStatusId);
      setFileYear(details.fileYear);
      setFileNumber(details.fileNumber);
      setOccupantsId(details.occupiantId);
      setMakaniNumber(details.makaniNumber || '');
      activeMarkerCallBack(details);
      setTimeout(() => {
        modal.toggle();
      }, 100);
    },
    [activeMarkerCallBack, modal]
  );
  useEffect(() => {
    setActMarker(activeMarker);
    if (activeMarker?.open) {
      handleActiveMarker(activeMarker);
    }
  }, [activeMarker, handleActiveMarker]);

  const openAddFormAtCoordinates = useCallback(
    (lat, lng, makaniNumber = '') => {
      setActMarker(null);
      setLocationContentId(0);
      setLocationStatusId(0);
      setFileYear(2023);
      setFileNumber('');
      setOccupantsId(0);
      setGx(lat);
      setGy(lng);
      setMakaniNumber(makaniNumber);
      setIsView(false);
      setTimeout(() => {
        modal.toggle();
      }, 100);
    },
    [modal]
  );

  useEffect(() => {
    if (!searchSelection?.autoOpen) return;
    if (!isValidLatLng(searchSelection)) return;
    openAddFormAtCoordinates(
      searchSelection.lat,
      searchSelection.lng,
      searchSelection.makaniNumber || ''
    );
  }, [searchSelection, openAddFormAtCoordinates]);

  const onMapClick = (e) => {
    openAddFormAtCoordinates(e.latLng.lat(), e.latLng.lng());
    console.log('====================================');
    console.log(e.latLng.lat(), e.latLng.lng());
    console.log('====================================');
  };
  const handleOnLoad = (map) => {
    // const bounds = new google.maps.LatLngBounds();
    // markers.forEach(({ position }) => bounds.extend(position));
    // map.fitBounds(bounds);
  };
  const handleClick = () => {
    handleFileInput.current.click();
  };
  const handlePhotoClick = () => {
    handlePhotoInput.current.click();
  };
  const getBase64 = (file, cb) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  const handleImageChange = (e) => {
    getBase64(e.target.files[0], (res) => {
      setDocImageObject([
        ...docImageObject,
        {
          file: res,
          name: e.target.files[0].name,
          mimeType: e.target.files[0].type,
          locationId: 0,
        },
      ]);
    });
  };
  const handlePhotoChange = (e) => {
    getBase64(e.target.files[0], (res) => {
      setPhotImageObject([
        ...photoImageObject,
        {
          file: res,
          name: e.target.files[0].name,
          mimeType: e.target.files[0].type,
          locationId: 0,
        },
      ]);
    });
  };
  return (
    <div>
      <div>
        <GoogleMap
          onLoad={handleOnLoad}
          onClick={onMapClick}
          zoom={14}
          center={center}
          mapContainerStyle={{ width: '100vw', height: '100vh' }}>
          {markers?.map((info, i) => (
            <MarkerF
              key={i + 1}
              position={{ lat: +info.gx, lng: +info.gy }}
              title=''
              options={{
                iconAnchor: [0, 14],
                iconSize: info.id === actMarker?.id ? [10, 10] : [12, 12],
                animation: info.id === actMarker?.id ? null : null,
                icon:
                  info.id === actMarker?.id
                    ? require('../images/pincourt.png')
                    : require('../images/pincourtgrey.png'),
              }}
              onClick={() => handleActiveMarker(info)}></MarkerF>
          ))}
          {searchMarker && (
            <MarkerF
              position={searchMarker}
              title=''
              onClick={() =>
                openAddFormAtCoordinates(
                  searchMarker.lat,
                  searchMarker.lng,
                  searchMarker.makaniNumber || ''
                )
              }
              options={{
                iconAnchor: [0, 14],
                iconSize: [12, 12],
                icon: require('../images/pincourt.png'),
              }}
            />
          )}
        </GoogleMap>
      </div>

      <div
        id='modalEl'
        tabIndex='-1'
        aria-hidden='true'
        className='fixed top-0  right-0 z-50 hidden w-full   overflow-x-hidden overflow-y-scroll md:inset-0 h-[100vh]'>
        <div className='w-full max-w-2xl  items-end flex flex-col gap-5 justify-end overflow-y-scroll'>
          <div
            dir={direction}
            className='relative flex flex-col px-4 gap-5 bg-white rounded-lg shadow max-h-screen min-h-screen overflow-y-scroll dark:bg-gray-700'>
            <div
              className={`flex  items-start  p-5 shadow -mx-4  dark:border-gray-600 `}>
              <h3 className='text-xl px-3 flex-grow font-medium text-gray-900 lg:text-2xl dark:text-white'>
                {isView ? (
                  <span> {t('LocationDetails')}</span>
                ) : (
                  <span>{t('AddLocations')}</span>
                )}
              </h3>
              <button
                type='button'
                onClick={() => {
                  modal.hide();
                }}
                className='text-gray-400 border-1 border  rounded-full bg-transparent hover:bg-gray-200 hover:text-gray-900   text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white'>
                <svg
                  className='w-3 h-3'
                  aria-hidden='true'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 14 14'>
                  <path
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6'
                  />
                </svg>
                <span className='sr-only'>Close modal</span>
              </button>
            </div>
            {!isView && (
              <div className='flex flex-col justify-between gap-3 px-5  dark:border-gray-600'>
                <h5 className='text-lg font-medium dark:text-white'>
                  {t('LocationDetails')}
                </h5>
                <h6> {t('Providesomeinformationaboutthisplace')}</h6>
              </div>
            )}

            {isView && (
              <div>
                <div className='flex flex-row items-center  p-4  border-b'>
                  <div className='flex flex-col flex-grow justify-center items-start'>
                    <div className='flex flex-col justify-between gap-4'>
                      <h4 className='text-zinc-800 text-base font-semibold'>
                        {caseDetails.locationTitle}
                      </h4>
                      {/* <h5 className="text-zinc-800 text-base font-normal">
                          {info.keySerial}
                        </h5> */}

                      <a
                        href={
                          'https://www.google.com/maps/dir/' +
                          caseDetails.gx +
                          ',' +
                          caseDetails.gy
                        }
                        target='_blank'
                        rel='noreferrer'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          x='0px'
                          y='0px'
                          width='50'
                          height='50'
                          viewBox='0 0 64 64'>
                          <path
                            fill='#fff7f0'
                            d='M57,28.33V51a6,6,0,0,1-6,6H13a6,6,0,0,1-6-6V13a6,6,0,0,1,6-6H39.23'></path>
                          <path
                            fill='#72caaf'
                            d='M7,51V13a6,6,0,0,1,6-6H39.23L39,19Z'></path>
                          <path
                            fill='#f9e3ae'
                            d='M13,57,9,56,7.17,52.17C7.17,48.85,42.5,16,42.5,16l.21,11.54Z'></path>
                          <path
                            fill='#97e0bb'
                            d='M57,7H12c-.55,0-4,2.45-4,3H8a4,4,0,0,0,4,4H58a4,4,0,0,0,4-4h0C62,9.45,57.55,7,57,7Z'></path>
                          <path
                            fill='#faefde'
                            d='M36.6,33.6,57,54c0-3.31.52-26.84.52-26.84l-14.79.41Z'></path>
                          <path
                            fill='#85cbf8'
                            d='M13 57L50 57 31.45 38.71 13 57z'></path>
                          <path
                            fill='#ed7899'
                            d='M37,14.28a13,13,0,0,1,26,0c0,9.39-11.56,17.33-13,28.84C48.56,31.62,37,23.67,37,14.28Z'></path>
                          <path
                            fill='#f9dd8f'
                            d='M50 9A5 5 0 1 0 50 19A5 5 0 1 0 50 9Z'></path>
                          <path
                            fill='#8d6c9f'
                            d='M17 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 17 16zM12 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 12 16zM32 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 32 16zM22 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 22 16zM27 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 27 16z'></path>
                          <path
                            fill='#8d6c9f'
                            d='M64,14.28A14,14,0,0,0,38.74,6H13a7,7,0,0,0-7,7V51c0,.12,0,.23,0,.35a1,1,0,0,0,0,.25A7,7,0,0,0,12.4,58a1,1,0,0,0,.16,0l.09,0L13,58H51a7,7,0,0,0,7-7V28.33s0,0,0,0C61.1,23.63,64,19.22,64,14.28Zm-14-12a12,12,0,0,1,12,12c0,4.4-2.82,8.62-5.8,13.09-2.38,3.56-4.81,7.21-6.2,11.34-1.38-4.13-3.82-7.78-6.2-11.34-3-4.47-5.8-8.69-5.8-13.09A12,12,0,0,1,50,2.28ZM13,8H37.51A13.89,13.89,0,0,0,36,14.28a15,15,0,0,0,1.18,5.6l-.1.06L8,49V13A5,5,0,0,1,13,8ZM8.08,51.78l30-30A52.77,52.77,0,0,0,41.15,27L12.22,55.92A5,5,0,0,1,8.08,51.78Zm23.14-12L47.47,56H15ZM51,56h-.7L32.64,38.33l3.64-3.64L40.54,39A1,1,0,0,0,42,37.54l-4.26-4.26,4.59-4.59c3,4.48,6,9.13,6.73,14.56a1,1,0,0,0,2,0c.55-4.38,2.65-8.25,5-11.94V51a4.9,4.9,0,0,1-.05.53l-4.37-4.37a1,1,0,0,0-1.41,1.41l5.07,5.07A5,5,0,0,1,51,56Z'></path>
                          <path
                            fill='#8d6c9f'
                            d='M50 12A2 2 0 1 0 50 16A2 2 0 1 0 50 12Z'></path>
                          <path
                            fill='#8d6c9f'
                            d='M50,20a6,6,0,0,0,6-6,1,1,0,0,0-2,0,4,4,0,1,1-5.2-3.82,1,1,0,1,0-.6-1.91A6,6,0,0,0,50,20Z'></path>
                          <path
                            fill='#8d6c9f'
                            d='M51.48 10.28a4 4 0 0 1 1.45 1 1 1 0 1 0 1.46-1.36 6 6 0 0 0-2.17-1.48 1 1 0 1 0-.74 1.86zM44.89 40.48a1 1 0 0 0-1.41 1.41l1.85 1.85a1 1 0 0 0 1.41-1.41z'></path>
                          <path
                            fill='#faefde'
                            d='M18,30a6,6,0,0,0,6-6,1,1,0,0,0-1-1H19.25a1,1,0,0,0,0,2h2.62a4,4,0,1,1-2-4.52,1,1,0,1,0,1-1.76A6,6,0,1,0,18,30Z'></path>
                        </svg>{' '}
                      </a>
                    </div>
                  </div>
                  <svg
                    width='35'
                    height='35'
                    className={`  ${appDir === 'ltr' ? '' : 'rotate-180'}`}
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <g id='Outline / Arrows / Alt Arrow Right'>
                      <path
                        id='Vector (Stroke)'
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M7.09327 3.69149C7.35535 3.46685 7.74991 3.4972 7.97455 3.75928L12.9745 9.59262C13.1752 9.82667 13.1752 10.172 12.9745 10.4061L7.97455 16.2394C7.74991 16.5015 7.35535 16.5319 7.09327 16.3072C6.83119 16.0826 6.80084 15.688 7.02548 15.426L11.6768 9.99936L7.02548 4.57277C6.80084 4.31069 6.83119 3.91613 7.09327 3.69149Z'
                        fill='#1C274C'
                      />
                    </g>
                  </svg>
                </div>
              </div>
            )}

            {/* Location Content Start  */}
            <div className='flex flex-col justify-between gap-3 px-5  dark:border-gray-600'>
              <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                {t('Status')}
              </h5>
            </div>
            {/* Location Content END  */}
            {/* Location Status Start  */}
            <div className='flex flex-row justify-between gap-3 px-5  dark:border-gray-600'>
              {locationStatuses?.map((locationStatuse) => {
                return (
                  <div
                    key={locationStatuse.id}
                    onClick={() => {
                      setLocationStatusId(locationStatuse.id);
                    }}
                    className={`flex flex-col justify-between p-4 max-w-md h-32 bg-white rounded-md  flex-grow ${
                      locationStatuse.id !== slocationStatusId && isView
                        ? 'hidden border-1 border-black'
                        : ''
                    } ${
                      locationStatuse.id === slocationStatusId
                        ? !isView
                          ? ' bg-neutral-100 border border-black'
                          : ' border'
                        : ' border'
                    }`}>
                    {locationStatuse.id === 1 && (
                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <g id='open-doors'>
                          <path
                            id='door-open'
                            d='M23.0412 7.58343V20.4168C23.0406 21.1128 22.7638 21.7801 22.2716 22.2722C21.7795 22.7644 21.1122 23.0411 20.4162 23.0418H18.6662C18.4341 23.0418 18.2115 22.9496 18.0475 22.7855C17.8834 22.6214 17.7912 22.3988 17.7912 22.1668C17.7912 21.9347 17.8834 21.7121 18.0475 21.548C18.2115 21.3839 18.4341 21.2918 18.6662 21.2918H20.4162C20.6482 21.2918 20.8708 21.1996 21.0349 21.0355C21.199 20.8714 21.2912 20.6488 21.2912 20.4168V7.58343C21.2912 7.35136 21.199 7.1288 21.0349 6.96471C20.8708 6.80062 20.6482 6.70843 20.4162 6.70843H18.6662C18.4341 6.70843 18.2115 6.61624 18.0475 6.45215C17.8834 6.28805 17.7912 6.06549 17.7912 5.83343C17.7912 5.60136 17.8834 5.3788 18.0475 5.21471C18.2115 5.05062 18.4341 4.95843 18.6662 4.95843H20.4162C21.1122 4.95905 21.7795 5.23581 22.2716 5.72796C22.7638 6.2201 23.0406 6.88743 23.0412 7.58343ZM16.2255 3.2026C16.5327 3.44805 16.7805 3.75962 16.9506 4.11412C17.1207 4.46862 17.2086 4.85691 17.2078 5.2501V22.7501C17.2078 23.4463 16.9313 24.114 16.439 24.6062C15.9467 25.0985 15.279 25.3751 14.5828 25.3751C14.3898 25.3749 14.1973 25.3538 14.0088 25.3121L7.00884 23.7569C6.42387 23.6296 5.90042 23.3051 5.52618 22.8379C5.15194 22.3706 4.94964 21.7889 4.95317 21.1903V6.80643C4.94964 6.20778 5.15194 5.62609 5.52618 5.15882C5.90042 4.69155 6.42387 4.36708 7.00884 4.23976L14.0088 2.6846C14.3935 2.59824 14.7926 2.59998 15.1765 2.68968C15.5604 2.77939 15.919 2.95473 16.2255 3.2026ZM15.4578 5.2501C15.4572 5.01842 15.365 4.7964 15.2013 4.63247C15.0376 4.46854 14.8157 4.37602 14.584 4.3751C14.5196 4.37504 14.4554 4.38248 14.3927 4.39726L7.39267 5.95243C7.19802 5.99489 7.02382 6.10285 6.89918 6.25828C6.77454 6.41371 6.707 6.6072 6.70784 6.80643V21.1938C6.707 21.393 6.77454 21.5865 6.89918 21.7419C7.02382 21.8973 7.19802 22.0053 7.39267 22.0478L14.3927 23.6029C14.5205 23.6314 14.6531 23.6308 14.7806 23.6012C14.9082 23.5716 15.0275 23.5137 15.1297 23.4319C15.2319 23.35 15.3145 23.2463 15.3713 23.1283C15.4281 23.0103 15.4576 22.881 15.4578 22.7501V5.2501ZM12.2728 12.8334H12.2612C11.9507 12.835 11.6535 12.9596 11.4348 13.1799C11.2161 13.4003 11.0937 13.6984 11.0945 14.0088C11.0953 14.3193 11.2192 14.6168 11.439 14.836C11.6588 15.0553 11.9565 15.1784 12.267 15.1784C12.5775 15.1784 12.8753 15.0553 13.0951 14.836C13.3149 14.6168 13.4387 14.3193 13.4395 14.0088C13.4403 13.6984 13.3179 13.4003 13.0992 13.1799C12.8805 12.9596 12.5833 12.835 12.2728 12.8334Z'
                            fill={
                              locationStatuse.id === slocationStatusId
                                ? 'black'
                                : 'gray'
                            }
                          />
                        </g>
                      </svg>
                    )}
                    {locationStatuse.id === 2 && (
                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <g id='close-doors'>
                          <path
                            id='door-closed'
                            d='M24.5 23.625H22.4583V5.25C22.4577 4.554 22.181 3.88668 21.6888 3.39453C21.1967 2.90238 20.5293 2.62562 19.8333 2.625H8.16667C7.47066 2.62562 6.80334 2.90238 6.31119 3.39453C5.81904 3.88668 5.54228 4.554 5.54167 5.25V23.625H3.5C3.26794 23.625 3.04538 23.7172 2.88128 23.8813C2.71719 24.0454 2.625 24.2679 2.625 24.5C2.625 24.7321 2.71719 24.9546 2.88128 25.1187C3.04538 25.2828 3.26794 25.375 3.5 25.375H24.5C24.7321 25.375 24.9546 25.2828 25.1187 25.1187C25.2828 24.9546 25.375 24.7321 25.375 24.5C25.375 24.2679 25.2828 24.0454 25.1187 23.8813C24.9546 23.7172 24.7321 23.625 24.5 23.625ZM7.29167 23.625V5.25C7.29167 5.01794 7.38385 4.79538 7.54795 4.63128C7.71204 4.46719 7.9346 4.375 8.16667 4.375H19.8333C20.0654 4.375 20.288 4.46719 20.4521 4.63128C20.6161 4.79538 20.7083 5.01794 20.7083 5.25V23.625H7.29167ZM18.69 14C18.69 14.2302 18.6218 14.4553 18.4942 14.6469C18.3665 14.8385 18.185 14.9881 17.9725 15.0767C17.7599 15.1653 17.526 15.1891 17.3 15.145C17.074 15.101 16.8661 14.991 16.7025 14.829C16.5389 14.667 16.4268 14.4602 16.3805 14.2347C16.3342 14.0091 16.3556 13.7749 16.4422 13.5616C16.5287 13.3482 16.6764 13.1652 16.8667 13.0356C17.057 12.906 17.2814 12.8356 17.5117 12.8333H17.5233C17.8328 12.8333 18.1295 12.9562 18.3483 13.175C18.5671 13.3938 18.69 13.6906 18.69 14Z'
                            fill={
                              locationStatuse.id === slocationStatusId
                                ? 'black'
                                : 'gray'
                            }
                          />
                        </g>
                      </svg>
                    )}
                    {locationStatuse.id === 3 && (
                      <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <g id='Outline / School / Diploma'>
                          <path
                            id='Vector'
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M9.26996 1.45899H18.7313C20.3269 1.45896 21.6129 1.45894 22.6244 1.59493C23.6745 1.73611 24.5587 2.03816 25.2609 2.74039C25.9631 3.44263 26.2652 4.32682 26.4064 5.37694C26.5424 6.38841 26.5423 7.67445 26.5423 9.26997V14.0647C26.5423 15.6602 26.5424 16.9462 26.4064 17.9577C26.2652 19.0078 25.9631 19.892 25.2609 20.5942C24.68 21.1751 23.972 21.4843 23.1428 21.6532C22.7202 21.7392 22.2518 21.7915 21.7359 21.8235C21.7385 21.8294 21.7411 21.8354 21.7437 21.8415C22.0621 22.5885 21.7904 23.4575 21.0672 23.8674C20.8497 23.9907 20.6159 24.0351 20.4524 24.0604C20.2816 24.0869 20.068 24.1078 19.8309 24.131L19.8078 24.1333C19.6553 24.1482 19.5687 24.1569 19.5043 24.1661C19.4751 24.1702 19.4597 24.1733 19.4535 24.1747C19.4353 24.1818 19.423 24.1907 19.4151 24.1983C19.4091 24.2039 19.4048 24.2097 19.4016 24.2156C19.4002 24.2221 19.3983 24.2328 19.3958 24.2485C19.3867 24.3073 19.378 24.3875 19.3623 24.5347L19.3597 24.5588C19.3357 24.7843 19.3136 24.9918 19.2854 25.1587C19.2583 25.3197 19.2096 25.5569 19.074 25.7767C18.6374 26.4847 17.7658 26.7036 17.0487 26.4227C16.8249 26.335 16.6452 26.1921 16.5156 26.0807C16.3828 25.9665 16.2264 25.8166 16.0513 25.6486L14.0007 23.6827L11.9501 25.6486C11.7749 25.8166 11.6185 25.9665 11.4857 26.0807C11.3561 26.1921 11.1764 26.335 10.9526 26.4227C10.2355 26.7036 9.36393 26.4847 8.92729 25.7767C8.79175 25.5569 8.743 25.3197 8.71586 25.1587C8.68771 24.9918 8.66561 24.7843 8.64158 24.5587L8.63903 24.5347C8.62335 24.3875 8.61457 24.3073 8.60546 24.2485C8.60302 24.2328 8.60106 24.2221 8.59974 24.2156C8.59652 24.2097 8.59216 24.2039 8.58625 24.1983C8.5783 24.1907 8.56601 24.1818 8.54781 24.1747C8.54165 24.1733 8.52621 24.1702 8.49696 24.1661C8.43263 24.1569 8.34604 24.1482 8.1935 24.1333L8.17037 24.131C7.93326 24.1078 7.71975 24.0869 7.54889 24.0604C7.38538 24.0351 7.15156 23.9907 6.93413 23.8674C6.2109 23.4575 5.9392 22.5885 6.25762 21.8415C6.26019 21.8354 6.26281 21.8294 6.26547 21.8234C5.80036 21.7946 5.37565 21.7494 4.98973 21.6785C4.1054 21.5161 3.35281 21.2067 2.74039 20.5942C2.03816 19.892 1.73612 19.0078 1.59493 17.9577C1.45894 16.9462 1.45896 15.6602 1.45899 14.0647V9.26997C1.45896 7.67444 1.45894 6.38841 1.59493 5.37694C1.73611 4.32682 2.03816 3.44263 2.74039 2.74039C3.44263 2.03816 4.32682 1.73611 5.37694 1.59493C6.3884 1.45894 7.67444 1.45896 9.26996 1.45899ZM7.8557 20.1212L8.80747 19.2088L9.63485 18.3814C9.78213 16.0984 11.6805 14.2923 14.0007 14.2923C16.3208 14.2923 18.2192 16.0984 18.3665 18.3814L19.1938 19.2087L20.1982 20.1716L20.1976 20.1207C21.3488 20.1085 22.1693 20.0655 22.7936 19.9384C23.3938 19.8161 23.7529 19.6274 24.0235 19.3568C24.3464 19.0339 24.5569 18.5806 24.672 17.7245C24.7905 16.8433 24.7923 15.6753 24.7923 14.0007V9.33399C24.7923 7.65933 24.7905 6.49137 24.672 5.61013C24.5569 4.75405 24.3464 4.30072 24.0235 3.97783C23.7006 3.65494 23.2472 3.44442 22.3912 3.32932C21.5099 3.21084 20.342 3.20899 18.6673 3.20899H9.33398C7.65933 3.20899 6.49137 3.21084 5.61013 3.32932C4.75405 3.44442 4.30072 3.65494 3.97783 3.97783C3.65494 4.30072 3.44442 4.75406 3.32932 5.61013C3.21084 6.49137 3.20899 7.65933 3.20899 9.33399V14.0007C3.20899 15.6753 3.21084 16.8433 3.32932 17.7245C3.44442 18.5806 3.65494 19.0339 3.97783 19.3568C4.26186 19.6408 4.64461 19.8359 5.30589 19.9573C5.93401 20.0727 6.74471 20.1103 7.8557 20.1212ZM17.9859 20.475C17.5116 21.5191 16.639 22.3439 15.5622 22.7554L17.2462 24.3699C17.3956 24.5131 17.5017 24.6146 17.5845 24.6899C17.5951 24.6015 17.607 24.4913 17.6221 24.3493C17.6242 24.33 17.6262 24.3103 17.6283 24.2903C17.6505 24.076 17.6769 23.8223 17.7654 23.5931C17.9613 23.0856 18.3697 22.7023 18.8732 22.5236C19.0999 22.4431 19.3508 22.4191 19.5767 22.3975C19.5971 22.3955 19.6173 22.3936 19.6372 22.3916C19.7626 22.3793 19.8651 22.3692 19.9506 22.3601C19.8841 22.295 19.8025 22.2166 19.7007 22.119L17.9859 20.475ZM14.0358 21.2921L14.0007 21.2584L13.9655 21.2921C12.532 21.2733 11.3757 20.1053 11.3757 18.6673C11.3757 17.2176 12.5509 16.0423 14.0007 16.0423C15.4504 16.0423 16.6257 17.2176 16.6257 18.6673C16.6257 20.1053 15.4694 21.2733 14.0358 21.2921ZM12.4391 22.7554L10.7551 24.3699C10.6058 24.5131 10.4996 24.6146 10.4168 24.6899C10.4062 24.6015 10.3943 24.4913 10.3792 24.3493C10.3771 24.33 10.3751 24.3103 10.373 24.2903C10.3508 24.076 10.3244 23.8223 10.2359 23.5931C10.04 23.0856 9.63157 22.7023 9.12809 22.5236C8.90136 22.4431 8.65045 22.4191 8.4246 22.3975C8.4042 22.3955 8.38401 22.3936 8.36406 22.3916C8.23872 22.3793 8.13621 22.3692 8.05071 22.3601C8.11717 22.295 8.19876 22.2166 8.30063 22.119L10.0154 20.475C10.4897 21.5191 11.3623 22.3439 12.4391 22.7554ZM9.62565 7.00065C9.62565 6.5174 10.0174 6.12565 10.5007 6.12565H17.5007C17.9839 6.12565 18.3757 6.5174 18.3757 7.00065C18.3757 7.4839 17.9839 7.87565 17.5007 7.87565H10.5007C10.0174 7.87565 9.62565 7.4839 9.62565 7.00065ZM7.29232 11.084C7.29232 10.6007 7.68407 10.209 8.16732 10.209H19.834C20.3172 10.209 20.709 10.6007 20.709 11.084C20.709 11.5672 20.3172 11.959 19.834 11.959H8.16732C7.68407 11.959 7.29232 11.5672 7.29232 11.084Z'
                            fill={
                              locationStatuse.id === slocationStatusId
                                ? 'black'
                                : 'gray'
                            }
                          />
                        </g>
                      </svg>
                    )}

                    <p
                      className={`text-sm font-medium leading-10 ${
                        locationStatuse.id === slocationStatusId
                          ? ' text-black'
                          : ' text-zinc-500 '
                      }`}>
                      {t(locationStatuse.title)}
                    </p>
                  </div>
                );
              })}
            </div>
            {/* Location Status End  */}

            {/* Occupants Start  */}
            <div className='flex flex-col justify-between gap-3 px-5  dark:border-gray-600'>
              <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                {t('Occupants')}
              </h5>
            </div>
            <div className='flex flex-row justify-start gap-3 px-5  dark:border-gray-600'>
              {occupiants?.map((occupiant) => {
                return (
                  <div
                    key={occupiant.id}
                    onClick={() => {
                      setOccupantsId(occupiant.id);
                    }}
                    className={`px-5 py-2 gap-2 items-center  flex flex-row   bg-white rounded-[56px] ${
                      occupiant.id !== soccupiantsId && isView
                        ? 'hidden border-1 border-black'
                        : ''
                    }   ${
                      occupiant.id === soccupiantsId
                        ? !isView
                          ? ' bg-neutral-100 border border-black'
                          : ' border'
                        : ' border'
                    }`}>
                    {occupiant.id === 1 && (
                      <svg
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <g clipPath='url(#clip0_463_2996)'>
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM2.0625 9C2.0625 5.16852 5.16852 2.0625 9 2.0625C10.7134 2.0625 12.2817 2.68363 13.492 3.71299C13.487 3.71764 13.4821 3.72239 13.4773 3.72725L3.72727 13.4771C3.72238 13.482 3.7176 13.4869 3.71292 13.492C2.6836 12.2816 2.0625 10.7133 2.0625 9ZM4.50787 14.2869C5.71824 15.3163 7.28658 15.9375 9 15.9375C12.8315 15.9375 15.9375 12.8315 15.9375 9C15.9375 7.28662 15.3164 5.71832 14.287 4.50797C14.2824 4.51296 14.2776 4.51789 14.2727 4.52276L4.52276 14.2726C4.51786 14.2775 4.5129 14.2823 4.50787 14.2869Z'
                            fill='#040101'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_463_2996'>
                            <rect width='18' height='18' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                    {occupiant.id === 2 && (
                      <svg
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M6.86992 8.715C6.84742 8.715 6.83242 8.715 6.80992 8.715C6.77242 8.7075 6.71992 8.7075 6.67492 8.715C4.49992 8.6475 2.85742 6.9375 2.85742 4.83C2.85742 2.685 4.60492 0.9375 6.74992 0.9375C8.89492 0.9375 10.6424 2.685 10.6424 4.83C10.6349 6.9375 8.98492 8.6475 6.89242 8.715C6.88492 8.715 6.87742 8.715 6.86992 8.715ZM6.74992 2.0625C5.22742 2.0625 3.98242 3.3075 3.98242 4.83C3.98242 6.33 5.15242 7.5375 6.64492 7.59C6.68992 7.5825 6.78742 7.5825 6.88492 7.59C8.35492 7.5225 9.50992 6.315 9.51742 4.83C9.51742 3.3075 8.27242 2.0625 6.74992 2.0625Z'
                          fill='black'
                        />
                        <path
                          d='M12.4048 8.8125C12.3823 8.8125 12.3598 8.8125 12.3373 8.805C12.0298 8.835 11.7148 8.6175 11.6848 8.31C11.6548 8.0025 11.8423 7.725 12.1498 7.6875C12.2398 7.68 12.3373 7.68 12.4198 7.68C13.5148 7.62 14.3698 6.72 14.3698 5.6175C14.3698 4.4775 13.4473 3.555 12.3073 3.555C11.9998 3.5625 11.7448 3.3075 11.7448 3C11.7448 2.6925 11.9998 2.4375 12.3073 2.4375C14.0623 2.4375 15.4948 3.87 15.4948 5.625C15.4948 7.35 14.1448 8.745 12.4273 8.8125C12.4198 8.8125 12.4123 8.8125 12.4048 8.8125Z'
                          fill='black'
                        />
                        <path
                          d='M6.87672 16.9125C5.40672 16.9125 3.92922 16.5375 2.81172 15.7875C1.76922 15.0975 1.19922 14.1525 1.19922 13.125C1.19922 12.0975 1.76922 11.145 2.81172 10.4475C5.06172 8.955 8.70672 8.955 10.9417 10.4475C11.9767 11.1375 12.5542 12.0825 12.5542 13.11C12.5542 14.1375 11.9842 15.09 10.9417 15.7875C9.81672 16.5375 8.34672 16.9125 6.87672 16.9125ZM3.43422 11.3925C2.71422 11.8725 2.32422 12.4875 2.32422 13.1325C2.32422 13.77 2.72172 14.385 3.43422 14.8575C5.30172 16.11 8.45172 16.11 10.3192 14.8575C11.0392 14.3775 11.4292 13.7625 11.4292 13.1175C11.4292 12.48 11.0317 11.865 10.3192 11.3925C8.45172 10.1475 5.30172 10.1475 3.43422 11.3925Z'
                          fill='black'
                        />
                        <path
                          d='M13.7546 15.5625C13.4921 15.5625 13.2596 15.3825 13.2071 15.1125C13.1471 14.805 13.3421 14.5125 13.6421 14.445C14.1146 14.3475 14.5496 14.16 14.8871 13.8975C15.3146 13.575 15.5471 13.17 15.5471 12.7425C15.5471 12.315 15.3146 11.91 14.8946 11.595C14.5646 11.34 14.1521 11.16 13.6646 11.0475C13.3646 10.98 13.1696 10.68 13.2371 10.3725C13.3046 10.0725 13.6046 9.87751 13.9121 9.94501C14.5571 10.0875 15.1196 10.3425 15.5771 10.695C16.2746 11.22 16.6721 11.9625 16.6721 12.7425C16.6721 13.5225 16.2671 14.265 15.5696 14.7975C15.1046 15.1575 14.5196 15.42 13.8746 15.5475C13.8296 15.5625 13.7921 15.5625 13.7546 15.5625Z'
                          fill='black'
                        />
                      </svg>
                    )}
                    {t(occupiant.title)}
                  </div>
                );
              })}
            </div>

            {/* Occupants End  */}

            {/* Location Content Start */}
            <div className='flex flex-col justify-between gap-3 px-5  dark:border-gray-600'>
              <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                {t('LocationContent')}
              </h5>
            </div>
            <div className='flex flex-row justify-start gap-3 px-5  dark:border-gray-600'>
              {locationContent?.map((locContent) => {
                return (
                  <div
                    onClick={() => {
                      setLocationContentId(locContent.id);
                    }}
                    key={locContent.id}
                    className={`px-5 py-2 gap-2 items-center  flex flex-row    bg-white rounded-[56px] border ${
                      locContent.id !== slocationContentId && isView
                        ? 'hidden border-1 border-black'
                        : ''
                    } ${
                      locContent.id === slocationContentId
                        ? !isView
                          ? '  bg-neutral-100 border border-black'
                          : ' border'
                        : ''
                    }`}>
                    {locContent.id === 1 && (
                      <svg
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <g clipPath='url(#clip0_463_2996)'>
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM2.0625 9C2.0625 5.16852 5.16852 2.0625 9 2.0625C10.7134 2.0625 12.2817 2.68363 13.492 3.71299C13.487 3.71764 13.4821 3.72239 13.4773 3.72725L3.72727 13.4771C3.72238 13.482 3.7176 13.4869 3.71292 13.492C2.6836 12.2816 2.0625 10.7133 2.0625 9ZM4.50787 14.2869C5.71824 15.3163 7.28658 15.9375 9 15.9375C12.8315 15.9375 15.9375 12.8315 15.9375 9C15.9375 7.28662 15.3164 5.71832 14.287 4.50797C14.2824 4.51296 14.2776 4.51789 14.2727 4.52276L4.52276 14.2726C4.51786 14.2775 4.5129 14.2823 4.50787 14.2869Z'
                            fill='black'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_463_2996'>
                            <rect width='18' height='18' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                    {locContent.id === 2 && (
                      <svg
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M11.6922 9.7575C9.26223 9.7575 7.28223 7.7775 7.28223 5.3475C7.28223 2.9175 9.26223 0.9375 11.6922 0.9375C14.1222 0.9375 16.1022 2.9175 16.1022 5.3475C16.1022 7.7775 14.1222 9.7575 11.6922 9.7575ZM11.6922 2.0625C9.88473 2.0625 8.40723 3.5325 8.40723 5.3475C8.40723 7.1625 9.87723 8.6325 11.6922 8.6325C13.5072 8.6325 14.9772 7.1625 14.9772 5.3475C14.9772 3.5325 13.4997 2.0625 11.6922 2.0625Z'
                          fill='black'
                        />
                        <path
                          d='M4.76995 15.1434C3.18745 15.1434 1.89746 13.8534 1.89746 12.2709C1.89746 10.6884 3.18745 9.39844 4.76995 9.39844C6.35245 9.39844 7.64246 10.6884 7.64246 12.2709C7.64246 13.8534 6.35245 15.1434 4.76995 15.1434ZM4.76995 10.5234C3.80995 10.5234 3.02246 11.3034 3.02246 12.2709C3.02246 13.2309 3.80245 14.0184 4.76995 14.0184C5.72995 14.0184 6.51746 13.2384 6.51746 12.2709C6.51746 11.3109 5.72995 10.5234 4.76995 10.5234Z'
                          fill='black'
                        />
                        <path
                          d='M12.4649 17.0627C11.0924 17.0627 9.98242 15.9452 9.98242 14.5802C9.98242 13.2077 11.0999 12.0977 12.4649 12.0977C13.8299 12.0977 14.9474 13.2152 14.9474 14.5802C14.9474 15.9452 13.8299 17.0627 12.4649 17.0627ZM12.4649 13.2151C11.7149 13.2151 11.1074 13.8226 11.1074 14.5726C11.1074 15.3226 11.7149 15.9302 12.4649 15.9302C13.2149 15.9302 13.8224 15.3226 13.8224 14.5726C13.8224 13.8301 13.2149 13.2151 12.4649 13.2151Z'
                          fill='black'
                        />
                      </svg>
                    )}
                    {locContent.id === 3 && (
                      <svg
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M9 11.0625C8.6925 11.0625 8.4375 10.8075 8.4375 10.5V6.75C8.4375 6.4425 8.6925 6.1875 9 6.1875C9.3075 6.1875 9.5625 6.4425 9.5625 6.75V10.5C9.5625 10.8075 9.3075 11.0625 9 11.0625Z'
                          fill='black'
                        />
                        <path
                          d='M9 13.4999C8.955 13.4999 8.9025 13.4924 8.85 13.4849C8.805 13.4774 8.76 13.4624 8.715 13.4399C8.67 13.4249 8.625 13.4024 8.58 13.3724C8.5425 13.3424 8.505 13.3124 8.4675 13.2824C8.3325 13.1399 8.25 12.9449 8.25 12.7499C8.25 12.5549 8.3325 12.3599 8.4675 12.2174C8.505 12.1874 8.5425 12.1574 8.58 12.1274C8.625 12.0974 8.67 12.0749 8.715 12.0599C8.76 12.0374 8.805 12.0224 8.85 12.0149C8.9475 11.9924 9.0525 11.9924 9.1425 12.0149C9.195 12.0224 9.24 12.0374 9.285 12.0599C9.33 12.0749 9.375 12.0974 9.42 12.1274C9.4575 12.1574 9.495 12.1874 9.5325 12.2174C9.6675 12.3599 9.75 12.5549 9.75 12.7499C9.75 12.9449 9.6675 13.1399 9.5325 13.2824C9.495 13.3124 9.4575 13.3424 9.42 13.3724C9.375 13.4024 9.33 13.4249 9.285 13.4399C9.24 13.4624 9.195 13.4774 9.1425 13.4849C9.0975 13.4924 9.045 13.4999 9 13.4999Z'
                          fill='black'
                        />
                        <path
                          d='M13.5449 16.6209H4.45486C2.99236 16.6209 1.87486 16.0884 1.30486 15.1284C0.74236 14.1684 0.81736 12.9309 1.52986 11.6484L6.07486 3.47336C6.82486 2.12336 7.85986 1.38086 8.99986 1.38086C10.1399 1.38086 11.1749 2.12336 11.9249 3.47336L16.4699 11.6559C17.1824 12.9384 17.2649 14.1684 16.6949 15.1359C16.1249 16.0884 15.0074 16.6209 13.5449 16.6209ZM8.99986 2.50586C8.29486 2.50586 7.60486 3.04586 7.05736 4.02086L2.51986 12.2034C2.00986 13.1184 1.92736 13.9584 2.27986 14.5659C2.63236 15.1734 3.41236 15.5034 4.46236 15.5034H13.5524C14.6024 15.5034 15.3749 15.1734 15.7349 14.5659C16.0949 13.9584 16.0049 13.1259 15.4949 12.2034L10.9424 4.02086C10.3949 3.04586 9.70486 2.50586 8.99986 2.50586Z'
                          fill='black'
                        />
                      </svg>
                    )}
                    {t(locContent.title)}
                  </div>
                );
              })}
            </div>
            {/* Location Content End */}
            {slocationContentId === 3 && !isView && (
              <div className='flex flex-col items-center  -mt-3 px-5 rounded dark:border-gray-600'>
                <div className='h-0 w-0 border-x-8 rounded-sm mr-56 border-x-transparent border-b-[14px]  border-b-gray-100 '></div>
                <div className='bg-gray-100 flex flex-row justify-center gap-3 px-3 py-2 rounded-full '>
                  {hazardLevels?.map((options, i) => {
                    return (
                      <div
                        key={i}
                        onClick={() => {
                          setHazardLevel(options.id);
                        }}
                        className={`px-5 py-2 gap-2 items-end  flex flex-row hover:rounded-full hover:shadow hover:bg-white   ${
                          options.id === shazardLevel
                            ? 'bg-white rounded-full'
                            : ''
                        } }`}>
                        {t(options.title)}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {slocationContentId === 3 && isView && (
              <div>
                {appDir === 'ltr'
                  ? caseDetails.hazardLevelEn
                  : caseDetails.hazardLevelAr}
              </div>
            )}
            {/* Makani Number Start */}
            <div className='flex flex-row justify-start gap-10 px-5  dark:border-gray-600'>
              <div className='flex flex-col justify-between gap-3 flex-grow   dark:border-gray-600'>
                <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                  {t('MakaniNumber')}
                </h5>
                <div
                  className={`flex flex-row py-2 items-center bg-white rounded-lg  border-black ${
                    isView ? '' : 'border border-1'
                  }`}>
                  <img
                    src={require('../images/makani.png')}
                    alt=''
                    className='px-3 py-1 h-9'
                  />
                  {!isView && (
                    <input
                      type='text'
                      value={smakaniNumber}
                      onChange={(e) => {
                        setMakaniNumber(e.target.value);
                      }}
                      placeholder={t('Entermakaninumber')}
                      className='flex-grow  border-0 rounded-lg   focus:ring-0'
                    />
                  )}
                  {isView && <div> {caseDetails.makaniNumber} </div>}
                </div>
              </div>
            </div>
            {/* Makani Number End */}

            {/* Generate Key  Start */}
            <div className='flex flex-row justify-start gap-10 px-5  dark:border-gray-600'>
              <div className='flex flex-row justify-start items-center gap-3 flex-grow   dark:border-gray-600'>
                {!isView && (
                  <>
                    <input
                      type='checkbox'
                      onChange={(e) => {
                        setNeedKeyNumber(e.target.checked);
                      }}
                      className='p-4 rounded-lg'
                    />
                    <h4 className='text-black text-lg font-normal'>
                      {t('Generatekeynumber')}
                    </h4>
                  </>
                )}
              </div>
            </div>
            {/* Generate Key  Start */}
            <hr className='m-5' />

            <div className='flex flex-col justify-between gap-3 px-5  flex-grow   dark:border-gray-600'>
              <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                {t('Filetype')}
              </h5>
              {!isView && (
                <Select
                  onChange={(e) => {
                    setFileTypeId(e.value);
                  }}
                  placeholder={t('SelectFiletype')}
                  className='bg-white rounded-lg border focus:ring-0'
                  classNamePrefix='sel2'
                  options={fileTypes}></Select>
              )}
              {isView && (
                <>
                  <h5 className='text-black font-bold'>
                    {caseDetails.fileTypeAr}
                  </h5>
                </>
              )}
            </div>

            {/* File Start */}
            <div className='flex flex-row justify-start gap-10 px-5  dark:border-gray-600'>
              <div className='flex flex-col justify-between gap-3 flex-grow   dark:border-gray-600'>
                <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                  {t('Filenumber')}
                </h5>
                {!isView && (
                  <input
                    type='text'
                    value={sfileNumber}
                    onChange={(e) => {
                      setFileNumber(e.target.value);
                    }}
                    placeholder={t('SelectFilenumber')}
                    className='bg-white rounded-lg border '
                  />
                )}
                {isView && (
                  <>
                    <h5 className='text-black font-bold'>
                      {caseDetails.fileNumber}
                    </h5>
                  </>
                )}
              </div>
              <div className='flex flex-col justify-between gap-3  flex-grow   dark:border-gray-600'>
                <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                  {t('Fileyear')}
                </h5>
                {!isView && (
                  <select
                    type='text'
                    onChange={(e) => {
                      setFileYear(e.target.value);
                    }}
                    placeholder={t('SelectFileyear')}
                    className='bg-white rounded-lg border '>
                    {years?.map((year) => {
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                )}
                {isView && (
                  <>
                    <h5 className='text-black font-bold'>
                      {caseDetails.fileYear}
                    </h5>
                  </>
                )}
              </div>
            </div>
            {/* File End */}

            {/* Guardian Start */}
            <div className='flex flex-row justify-start gap-10 px-5  dark:border-gray-600'>
              <div className='flex flex-col justify-between gap-3  flex-grow   dark:border-gray-600'>
                <h5 className='text-lg font-medium text-red-700 dark:text-white'>
                  {t('GuardianName')}
                </h5>
                {!isView && (
                  <input
                    type='text'
                    placeholder={t('PleaseenterGuardianName')}
                    className='bg-white rounded-lg border '
                    value={sguardianname}
                    onChange={(e) => {
                      setGuardianName(e.target.value);
                    }}></input>
                )}
                {isView && (
                  <>
                    <h5 className='text-black font-bold'>
                      {caseDetails.guardianName}
                    </h5>
                  </>
                )}
                {/* <select
                  type='text'
                  placeholder='Select Guardian Name'
                  onChange={(e) => {
                    setGuardianId(e.target.value);
                  }}
                  className='bg-white rounded-lg border '>
                  {guardians?.map((guardian) => {
                    return (
                      <option key={guardian.id} value={guardian.id}>
                        {guardian.title}
                      </option>
                    );
                  })}
                </select> */}
              </div>
            </div>
            {/* Guardian End */}

            <hr className={`${isView ? 'mx-5' : 'mx-5 my-2'}`} />

            {/* Documents Start */}
            <div className='flex flex-col justify-between gap-3 px-5  dark:border-gray-600'>
              <h5 className='text-lg text-red-700 font-medium dark:text-white'>
                {t('DocumentType')}
              </h5>
              {!isView && (
                <select
                  type='text'
                  placeholder='Select Guardian Name'
                  onChange={(e) => {
                    setDocumentTypId(e.target.value);
                  }}
                  className='bg-white rounded-lg border '>
                  {documentTypes?.map((documentType) => {
                    return (
                      <option key={documentType.id} value={documentType.id}>
                        {direction === 'ltr'
                          ? documentType.title
                          : documentType.titleAr === ''
                          ? documentType.titleAr
                          : documentType.title}
                      </option>
                    );
                  })}
                </select>
              )}

              <div className='flex flex-row gap-5 my-4'>
                {!isView &&
                  docImageObject?.map((DocImageObject, i) => {
                    return (
                      <div className=' relative' key={i}>
                        <button
                          type='button'
                          onClick={() => {
                            setDocImageObject((current) =>
                              current.filter(
                                (item) => item.name !== DocImageObject.name
                              )
                            );
                          }}
                          className='text-gray-400 absolute -right-2 -top-2 border-1 border rounded-full bg-white hover:bg-gray-200 hover:text-gray-900   text-sm w-6 h-6 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white'>
                          <svg
                            className='w-3 h-3'
                            aria-hidden='true'
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 14 14'>
                            <path
                              stroke='currentColor'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6'
                            />
                          </svg>
                          <span className='sr-only'>Close modal</span>
                        </button>
                        <div className='border border-gray-200 flex flex-col gap-4 px-2 py-4 rounded'>
                          <svg
                            width='24'
                            height='32'
                            viewBox='0 0 24 32'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <path
                              d='M23.8047 6.862L17.138 0.195312C17.013 0.0703125 16.8438 0 16.6666 0H2.66663C1.19594 0 0 1.19594 0 2.66669V29.3334C0 30.8041 1.19594 32 2.66669 32H21.3334C22.8041 32 24 30.8041 24 29.3333V7.33331C24 7.15625 23.9297 6.987 23.8047 6.862ZM17.3333 2.27606L21.7239 6.66669H18.6666C17.9316 6.66669 17.3333 6.06838 17.3333 5.33337V2.27606ZM22.6667 29.3333C22.6667 30.0683 22.0684 30.6666 21.3334 30.6666H2.66669C1.93169 30.6666 1.33337 30.0683 1.33337 29.3333V2.66669C1.33337 1.93169 1.93169 1.33337 2.66669 1.33337H16V5.33337C16 6.80406 17.1959 8 18.6667 8H22.6667V29.3333Z'
                              fill='#828282'
                            />
                            <path
                              d='M15.3991 19.5723C14.7819 19.0866 14.1953 18.5873 13.8047 18.1967C13.2969 17.6888 12.8444 17.1967 12.4512 16.7279C13.0645 14.8327 13.3334 13.8555 13.3334 13.3347C13.3334 11.1218 12.5339 10.668 11.3334 10.668C10.4212 10.668 9.33337 11.1419 9.33337 13.3985C9.33337 14.3933 9.87831 15.601 10.9584 17.0046C10.6941 17.8112 10.3835 18.7416 10.0346 19.7904C9.86656 20.2937 9.68431 20.7598 9.49156 21.1908C9.33469 21.2605 9.18231 21.3314 9.03519 21.405C8.50525 21.67 8.002 21.9082 7.53519 22.1296C5.40625 23.1374 4 23.8041 4 25.1205C4 26.0762 5.03844 26.668 6 26.668C7.23956 26.668 9.11131 25.0123 10.4785 22.2233C11.8978 21.6634 13.6621 21.2487 15.0547 20.9889C16.1706 21.847 17.403 22.668 18 22.668C19.653 22.668 20 21.7122 20 20.9108C20 19.3346 18.1992 19.3346 17.3333 19.3346C17.0644 19.3347 16.3431 19.4141 15.3991 19.5723ZM6 25.3347C5.61913 25.3347 5.36131 25.155 5.33331 25.1205C5.33331 24.6478 6.74281 23.9798 8.10612 23.334C8.19269 23.293 8.28063 23.252 8.36981 23.2097C7.3685 24.6615 6.37825 25.3347 6 25.3347ZM10.6667 13.3985C10.6667 12.0013 11.1003 12.0013 11.3334 12.0013C11.8047 12.0013 12.0001 12.0013 12.0001 13.3347C12.0001 13.6159 11.8126 14.319 11.4694 15.4167C10.9459 14.6107 10.6667 13.92 10.6667 13.3985ZM11.1777 20.5638C11.2194 20.448 11.2598 20.3308 11.2989 20.2123C11.5462 19.4701 11.7689 18.8034 11.9675 18.2032C12.2442 18.5078 12.5424 18.8197 12.8621 19.1393C12.9871 19.2643 13.2969 19.5456 13.7097 19.8978C12.888 20.0768 12.0137 20.2988 11.1777 20.5638ZM18.6667 20.9108C18.6667 21.2103 18.6667 21.3347 18.0482 21.3386C17.8666 21.2995 17.4466 21.0522 16.9284 20.6993C17.1165 20.6785 17.2552 20.668 17.3333 20.668C18.3184 20.668 18.5977 20.7643 18.6667 20.9108Z'
                              fill='#828282'
                            />
                          </svg>
                          <h2 className='text-sm max-w-[5vw] whitespace-nowrap flex-nowrap inline-flex overflow-x-hidden overflow-y-hidden'>
                            {DocImageObject.name}
                          </h2>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {!isView && (
                <div
                  onClick={handleClick}
                  className='px-4 py-5 flex flex-col bg-gray-100 justify-center items-center  border-dashed border-2 rounded'>
                  <input
                    type='file'
                    accept='image/*'
                    className='hidden'
                    ref={handleFileInput}
                    onChange={handleImageChange}></input>
                  <svg
                    width='35'
                    height='35'
                    viewBox='0 0 26 26'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M12.4258 16.7588C12.7431 16.4415 13.2576 16.4415 13.5749 16.7588L15.7415 18.9255C16.0588 19.2428 16.0588 19.7572 15.7415 20.0745C15.4242 20.3918 14.9098 20.3918 14.5925 20.0745L13.8128 19.2949V23.8333C13.8128 24.2821 13.4491 24.6458 13.0003 24.6458C12.5516 24.6458 12.1878 24.2821 12.1878 23.8333V19.2949L11.4082 20.0745C11.0909 20.3918 10.5764 20.3918 10.2591 20.0745C9.94183 19.7572 9.94183 19.2428 10.2591 18.9255L12.4258 16.7588Z'
                      fill='#828282'
                    />
                    <path
                      d='M13.5162 4.0625C10.5369 4.0625 8.13822 6.44673 8.13822 9.36765C8.13822 9.86832 8.20831 10.3518 8.33906 10.8096C8.87768 10.9651 9.3819 11.2005 9.83748 11.5018C10.2117 11.7494 10.3144 12.2535 10.0669 12.6278C9.81929 13.002 9.3152 13.1047 8.94095 12.8571C8.5284 12.5842 8.05943 12.3885 7.55473 12.2906C7.31442 12.2439 7.06544 12.2194 6.80985 12.2194C4.68531 12.2194 2.97949 13.9189 2.97949 15.9951C2.97949 18.0713 4.68531 19.7708 6.80985 19.7708C7.25858 19.7708 7.62235 20.1346 7.62235 20.5833C7.62235 21.0321 7.25858 21.3958 6.80985 21.3958C3.80603 21.3958 1.35449 18.9869 1.35449 15.9951C1.35449 13.0655 3.70519 10.6947 6.6233 10.5975C6.55095 10.198 6.51322 9.78698 6.51322 9.36765C6.51322 5.53119 9.65765 2.4375 13.5162 2.4375C16.9374 2.4375 19.7954 4.86817 20.401 8.09387C22.8926 9.15146 24.6462 11.6017 24.6462 14.4657C24.6462 17.7958 22.2762 20.5663 19.1286 21.2395C18.6898 21.3333 18.258 21.0536 18.1641 20.6148C18.0703 20.176 18.3499 19.7442 18.7887 19.6504C21.2151 19.1315 23.0212 17.0007 23.0212 14.4657C23.0212 12.1509 21.5161 10.1734 19.4054 9.45169C18.8545 9.26328 18.2619 9.16054 17.6432 9.16054C17.012 9.16054 16.408 9.26747 15.8476 9.4632C15.424 9.61117 14.9606 9.3877 14.8126 8.96407C14.6647 8.54044 14.8881 8.07706 15.3118 7.92909C16.0422 7.67395 16.8273 7.53554 17.6432 7.53554C17.9633 7.53554 18.2786 7.55684 18.5878 7.59814C17.8505 5.54267 15.8627 4.0625 13.5162 4.0625Z'
                      fill='#828282'
                    />
                  </svg>
                  <div className='text-zinc-500 text-sm font-medium leading-10'>
                    {t('UploadDocuments')}
                  </div>
                </div>
              )}
              {isView && caseDetails?.documents?.length > 0 && (
                <div className=''>
                  {caseDetails?.documents.map((document) => {
                    return (
                      <div className=' relative' key={document.locationId}>
                        <a
                          target='_blank'
                          href={document.url}
                          className='border border-gray-200 w-fit flex flex-col gap-4 px-2 py-4 rounded'
                          rel='noreferrer'>
                          <svg
                            width='24'
                            height='32'
                            viewBox='0 0 24 32'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <path
                              d='M23.8047 6.862L17.138 0.195312C17.013 0.0703125 16.8438 0 16.6666 0H2.66663C1.19594 0 0 1.19594 0 2.66669V29.3334C0 30.8041 1.19594 32 2.66669 32H21.3334C22.8041 32 24 30.8041 24 29.3333V7.33331C24 7.15625 23.9297 6.987 23.8047 6.862ZM17.3333 2.27606L21.7239 6.66669H18.6666C17.9316 6.66669 17.3333 6.06838 17.3333 5.33337V2.27606ZM22.6667 29.3333C22.6667 30.0683 22.0684 30.6666 21.3334 30.6666H2.66669C1.93169 30.6666 1.33337 30.0683 1.33337 29.3333V2.66669C1.33337 1.93169 1.93169 1.33337 2.66669 1.33337H16V5.33337C16 6.80406 17.1959 8 18.6667 8H22.6667V29.3333Z'
                              fill='#828282'
                            />
                            <path
                              d='M15.3991 19.5723C14.7819 19.0866 14.1953 18.5873 13.8047 18.1967C13.2969 17.6888 12.8444 17.1967 12.4512 16.7279C13.0645 14.8327 13.3334 13.8555 13.3334 13.3347C13.3334 11.1218 12.5339 10.668 11.3334 10.668C10.4212 10.668 9.33337 11.1419 9.33337 13.3985C9.33337 14.3933 9.87831 15.601 10.9584 17.0046C10.6941 17.8112 10.3835 18.7416 10.0346 19.7904C9.86656 20.2937 9.68431 20.7598 9.49156 21.1908C9.33469 21.2605 9.18231 21.3314 9.03519 21.405C8.50525 21.67 8.002 21.9082 7.53519 22.1296C5.40625 23.1374 4 23.8041 4 25.1205C4 26.0762 5.03844 26.668 6 26.668C7.23956 26.668 9.11131 25.0123 10.4785 22.2233C11.8978 21.6634 13.6621 21.2487 15.0547 20.9889C16.1706 21.847 17.403 22.668 18 22.668C19.653 22.668 20 21.7122 20 20.9108C20 19.3346 18.1992 19.3346 17.3333 19.3346C17.0644 19.3347 16.3431 19.4141 15.3991 19.5723ZM6 25.3347C5.61913 25.3347 5.36131 25.155 5.33331 25.1205C5.33331 24.6478 6.74281 23.9798 8.10612 23.334C8.19269 23.293 8.28063 23.252 8.36981 23.2097C7.3685 24.6615 6.37825 25.3347 6 25.3347ZM10.6667 13.3985C10.6667 12.0013 11.1003 12.0013 11.3334 12.0013C11.8047 12.0013 12.0001 12.0013 12.0001 13.3347C12.0001 13.6159 11.8126 14.319 11.4694 15.4167C10.9459 14.6107 10.6667 13.92 10.6667 13.3985ZM11.1777 20.5638C11.2194 20.448 11.2598 20.3308 11.2989 20.2123C11.5462 19.4701 11.7689 18.8034 11.9675 18.2032C12.2442 18.5078 12.5424 18.8197 12.8621 19.1393C12.9871 19.2643 13.2969 19.5456 13.7097 19.8978C12.888 20.0768 12.0137 20.2988 11.1777 20.5638ZM18.6667 20.9108C18.6667 21.2103 18.6667 21.3347 18.0482 21.3386C17.8666 21.2995 17.4466 21.0522 16.9284 20.6993C17.1165 20.6785 17.2552 20.668 17.3333 20.668C18.3184 20.668 18.5977 20.7643 18.6667 20.9108Z'
                              fill='#828282'
                            />
                          </svg>
                          <h2 className='text-sm max-w-[5vw] whitespace-nowrap flex-nowrap inline-flex overflow-x-hidden overflow-y-hidden'>
                            {document.name}
                          </h2>
                        </a>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {/* Documents End */}
            <hr className={`${isView ? 'mx-5' : 'm-5'}`} />
            {/* Photos Start */}
            <div className='flex flex-col justify-between gap-3 px-5  dark:border-gray-600'>
              {!isView && photoImageObject.length === 0 && (
                <h5 className='text-lg text-red-700 font-medium dark:text-white'>
                  {t('Photos')}
                </h5>
              )}

              <div className='flex flex-row gap-3'>
                {!isView &&
                  photoImageObject?.map((photoImageObj, i) => {
                    return (
                      <div
                        className='p-0 border w-25 h-25  flex flex-col items-center justify-center rounded relative'
                        key={i}>
                        <button
                          type='button'
                          onClick={() => {
                            setPhotImageObject((current) =>
                              current.filter(
                                (item) => item.name !== photoImageObj.name
                              )
                            );
                          }}
                          className='text-gray-400 absolute -right-2 -top-2 border-1 border rounded-full bg-white hover:bg-gray-200 hover:text-gray-900   text-sm w-6 h-6 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white'>
                          <svg
                            className='w-3 h-3'
                            aria-hidden='true'
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 14 14'>
                            <path
                              stroke='currentColor'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6'
                            />
                          </svg>
                          <span className='sr-only'>Close modal</span>
                        </button>
                        <img
                          className='max-h-20 min-w-18 w-auto h-100'
                          src={photoImageObj.file}
                          alt={photoImageObj.name}
                        />
                      </div>
                    );
                  })}
                {!isView && (
                  <div
                    className='p-5  border-dashed border border-1   rounded '
                    onClick={handlePhotoClick}>
                    <input
                      type='file'
                      accept='image/*'
                      className='hidden'
                      ref={handlePhotoInput}
                      onChange={handlePhotoChange}></input>
                    <svg
                      width='50'
                      height='50'
                      viewBox='0 0 50 50'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M37.5 26.5625H12.5C11.6458 26.5625 10.9375 25.8542 10.9375 25C10.9375 24.1458 11.6458 23.4375 12.5 23.4375H37.5C38.3542 23.4375 39.0625 24.1458 39.0625 25C39.0625 25.8542 38.3542 26.5625 37.5 26.5625Z'
                        fill='#828282'
                      />
                      <path
                        d='M25 39.0625C24.1458 39.0625 23.4375 38.3542 23.4375 37.5V12.5C23.4375 11.6458 24.1458 10.9375 25 10.9375C25.8542 10.9375 26.5625 11.6458 26.5625 12.5V37.5C26.5625 38.3542 25.8542 39.0625 25 39.0625Z'
                        fill='#828282'
                      />
                    </svg>
                  </div>
                )}
              </div>
            </div>

            {isView && caseDetails?.photos?.length > 0 && (
              <div className='flex flex-col justify-between gap-3 px-5  dark:border-gray-600'>
                <h5 className='text-lg font-medium dark:text-white'>
                  {t('Photos')}
                </h5>
                {caseDetails?.photos.map((photo) => {
                  return (
                    <a
                      target='_blank'
                      href={photo.url}
                      className='p-0 border w-25 h-25 w-fit max-w-sm flex flex-col items-center justify-center rounded relative'
                      key={photo.locationId}
                      rel='noreferrer'>
                      <img
                        className='max-h-20 min-w-18 w-auto h-100'
                        src={photo.url}
                        alt={photo.name}
                      />
                    </a>
                  );
                })}
              </div>
            )}
            {/* Photos End */}

            {!isView && (
              <div className='flex flex-col gap-2 p-6 border-gray-200 rounded-b dark:border-gray-600'>
                {submitError && (
                  <div className='text-red-600 text-sm'>{submitError}</div>
                )}
                <div className='flex flex-row items-center space-x-2'>
                  <button
                    type='button'
                    onClick={() => {
                      modal.hide();
                    }}
                    className='text-black  flex-grow  max-w-xl  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium bg-white rounded-[56px] border border-zinc-500 text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'>
                    {t('Cancel')}
                  </button>
                  <button
                    type='button'
                    onClick={handleSubmit}
                    disabled={loading}
                    className={`text-white flex-grow flex-row max-w-xl rounded-[56px] shadow border focus:ring-4 focus:outline-none focus:ring-blue-300 text-sm font-medium px-5 py-3 focus:z-10 ${
                      loading
                        ? 'bg-red-300 cursor-not-allowed'
                        : 'bg-red-500'
                    }`}>
                    {loading && <Loader color={'white'} />}
                    <span> {t('Update')} </span>
                  </button>
                </div>
              </div>
            )}
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Map;
